import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useBlocker } from 'react-router-dom';
import Sheet from './Sheet';
const Status = createContext({ dirty: false, discard: () => {} });
export const useEditStatus = () => useContext(Status);
const Context = createContext<(id: symbol, dirty: boolean) => void>(() => {});
export function useEditProtection(dirty: boolean) {
  const register = useContext(Context);
  const id = useRef(Symbol());
  useEffect(() => { const key = id.current; register(key, dirty); return () => register(key, false); }, [dirty, register]);
}
export default function EditProtection({ children }: { children: React.ReactNode }) {
  const [edits, setEdits] = useState<Set<symbol>>(new Set());
  const register = useCallback((id: symbol, dirty: boolean) => setEdits(old => {
    if (old.has(id) === dirty) return old;
    const next = new Set(old); dirty ? next.add(id) : next.delete(id); return next;
  }), []);
  const dirty = edits.size > 0;
  const blocker = useBlocker(dirty);
  useEffect(() => {
    const prevent = (event: BeforeUnloadEvent) => { if (dirty) { event.preventDefault(); event.returnValue = ''; } };
    window.addEventListener('beforeunload', prevent);
    return () => window.removeEventListener('beforeunload', prevent);
  }, [dirty]);
  return <Status.Provider value={{ dirty, discard: () => setEdits(new Set()) }}><Context.Provider value={register}>{children}
    {blocker.state === 'blocked' && <Sheet title="Leave with unsaved changes?" onClose={() => blocker.reset()}>
      <p>Your changes have not been submitted. Stay to save them.</p>
      <div className="cs-actions"><button onClick={() => blocker.reset()}>Keep editing</button>
      <button onClick={() => blocker.proceed()}>Discard and leave</button></div>
    </Sheet>}
  </Context.Provider></Status.Provider>;
}
